/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description React Hook useDeletePaymentRecord
 */
import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import api from 'client/index';
import QUERY_KEYS from 'app-constants/queryKeys';
import AppEvents from '@veritable/common/utils/appEvents';
import { getPaymentsPath, PAYMENT_TABS } from 'utils/router';

/**
 * useDeletePaymentRecord
 * @returns {UseMutationResult} useCreatePayment
 */
const useDeletePaymentRecord = (id: string, isDelete: boolean): UseMutationResult<unknown, IAxiosError, void, unknown> => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async () => {
			const { data } = await api.PaymentReconciliationApi.deletePaymentReconciliation({
				paymentReconciliationId: id,
				cancelPayment: isDelete,
			});
			return data;
		},
		onSuccess: () => {
			AppEvents.publishApiSuccess();
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.paymentAllocation, { id }] });
			queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.allPaymentAllocations] });
			if (isDelete) {
				AppEvents.publishRedirect({ url: getPaymentsPath({ tab: PAYMENT_TABS.values.unallocated }) });
			}
		},
		onError: (error) => {
			AppEvents.publishApiError({ error });
		},
	});
};

export default useDeletePaymentRecord;
